export default __webpack_public_path__ + "static/media/SnailReads.dab7f093.png";